import i18n from '@/i18n';

const methods = {
  convertDateFormat: (format, dateText) => {
    if (!dateText) return '';
    switch (format) {
      // YYYY년 월 일 변환
      case 'YYYYMMDD': {
        const dateArr = dateText.split('-');
        return i18n.t('common.date.yearMonthDay', [dateArr[0], dateArr[1], dateArr[2]]);
      }
      // YY년 월 일 변환
      case 'YYMMDD': {
        const dateArr = dateText.split('-');
        return i18n.t('common.date.yearMonthDay', [dateArr[0].substring(2), dateArr[1], dateArr[2]]);
      }
      // 년 월 변환
      case 'YYYYMM': {
        const dateArr = dateText.split('-');
        return i18n.t('common.date.yearMonth', [dateArr[0], dateArr[1]]);
      }
      // 년 월 일 사이 점 추가
      case 'dot': {
        return i18n.t('common.date.yearMonthDayDot', [dateText.substring(0, 4), dateText.substring(4, 6), dateText.substring(6, 8)]);
      }
      case 'dashDot': {
        const dateArr = dateText.split('-');
        return i18n.t('common.date.yearMonthDayDot', [dateArr[0], dateArr[1], dateArr[2]]);
      }
      case 'dash': {
        return i18n.t('common.date.yearMonthDayDash', [dateText.substring(0, 4), dateText.substring(4, 6), dateText.substring(6, 8)]);
      }
      // 년 월 일 시간 변환
      case 'YYYYMMDDTime': {
        const dateTimeArr = dateText.split(' ');
        const dateArr = dateTimeArr[0].split('-');
        const timeArr = dateTimeArr[1].split(':');
        let timeTxt = '';
        let hour = parseInt(timeArr[0]);
        hour = hour > 9 ? `${hour}` : `0${hour}`;
        timeTxt = `${hour}:${timeArr[1]}:${timeArr[2]}`;
        return `${i18n.t('common.date.yearMonthDayDot', [dateArr[0], dateArr[1], dateArr[2]])} ${timeTxt}`;
      }
      case 'Time': {
        const dateTimeArr = dateText.split(' ');
        const timeArr = dateTimeArr[1].split(':');
        let hour = parseInt(timeArr[0]);
        hour = hour > 9 ? `${hour}` : `0${hour}`;
        return `${hour}:${timeArr[1]}:${timeArr[2]}`;
      }
      case 'YYYYMMDDDayOfWeek': {
        const dayWeek = i18n.t('common.date.dayOfWeek').split(' ');
        const dateTimeArr = dateText.split(' ');
        const dateArr = dateTimeArr[0].split('-');
        const tempDate = new Date(dateTimeArr[0]);
        return `${i18n.t('common.date.yearMonthDay', [dateArr[0], dateArr[1], dateArr[2]])}(${dayWeek[tempDate.getDay()]})`;
      }
      case 'YYYYMMDDDayOfWeekTime': {
        const dayWeek = i18n.t('common.date.dayOfWeek').split(' ');
        const dateTimeArr = dateText.split(' ');
        const dateArr = dateTimeArr[0].split('-');
        const timeArr = dateTimeArr[1].split(':');
        let hour = parseInt(timeArr[0]);
        hour = hour > 9 ? `${hour}` : `0${hour}`;
        const tempDate = new Date(dateTimeArr[0]);
        return `${i18n.t('common.date.yearMonthDay', [dateArr[0], dateArr[1], dateArr[2]])}(${dayWeek[tempDate.getDay()]}), ${hour}:${timeArr[1]}:${timeArr[2]}`;
        //return `${i18n.t('common.date.yearMonthDay', [dateArr[0], dateArr[1], dateArr[2]])}(${dayWeek[tempDate.getDay()]}), ${hour}:${timeArr[1]}:${timeArr[2]}`;
      }
			case 'YYYYMMDDDayOfWeekTimeExceptSecond': {
        const dayWeek = i18n.t('common.date.dayOfWeek').split(' ');
        const dateTimeArr = dateText.split(' ');
        const dateArr = dateTimeArr[0].split('-');
        const timeArr = dateTimeArr[1].split(':');
        let hour = parseInt(timeArr[0]);
        hour = hour > 9 ? `${hour}` : `0${hour}`;
        const tempDate = new Date(dateTimeArr[0]);
        return `${i18n.t('common.date.yearMonthDay', [dateArr[0], dateArr[1], dateArr[2]])}(${dayWeek[tempDate.getDay()]}), ${hour}:${timeArr[1]}}`;
      }
      default:
        return '';
    }
  },
};

export default {
  install(Vue) {
    Vue.prototype.$convertDateFormat = methods.convertDateFormat;
  },
};
